import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-104f15d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "tool-container",
  ref: "container",
  "data-ignore": "1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatingTool = _resolveComponent("FloatingTool")!

  return (_openBlock(), _createBlock(_component_FloatingTool, {
    title: _ctx.title,
    "tool-name": _ctx.type,
    width: _ctx.width,
    height: _ctx.height,
    "show-footer": false,
    onSectionChange: _ctx.handleSectionChange
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, null, 512)
    ]),
    _: 1
  }, 8, ["title", "tool-name", "width", "height", "onSectionChange"]))
}